var _path, _path2, _path3, _path4, _path5, _text, _text2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOwner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_4378",
    "data-name": "Group 4378",
    xmlns: "http://www.w3.org/2000/svg",
    width: 134.202,
    height: 69.383,
    viewBox: "0 0 134.202 69.383",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M89.682,124.9a32.383,32.383,0,0,1,32.383-32.383c7.392,0,15.251,3.425,20.7,7.594-5.9-5.811-15.05-10.343-23.989-10.343a32.716,32.716,0,0,0-15.41,61.574A32.341,32.341,0,0,1,89.682,124.9Z",
    transform: "translate(-86.064 -89.766)",
    fill: "#ee2738"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M169.957,109.62a29.3,29.3,0,0,0-41-.587,34.3,34.3,0,0,1,41,.587Z",
    transform: "translate(-113.255 -96.86)",
    fill: "#262525"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M103.818,170.341a24.993,24.993,0,0,0,13.94,32.077,29.256,29.256,0,0,1-13.94-32.077Z",
    transform: "translate(-96.271 -140.845)",
    fill: "#262525"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M192.811,133.135l-19.892,20.108-1.423-1.516Z",
    transform: "translate(-140.222 -117.259)",
    fill: "#867970"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M147.114,158l11.107,8.8-1.407,1.531Z",
    transform: "translate(-124.765 -133.024)",
    fill: "#867970"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "TYMEPLUS",
    transform: "translate(36.202 50.383)",
    fill: "#867970",
    fontSize: 18,
    fontFamily: "Helvetica"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "TYMEPLUS"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    id: "Owner",
    transform: "translate(93.202 66.383)",
    fill: "#867970",
    fontSize: 13,
    fontFamily: "Helvetica"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Owner"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOwner);
export default __webpack_public_path__ + "static/media/owner.5ceca23fab7e41e33552b0505ed5153c.svg";
export { ForwardRef as ReactComponent };